module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABqSURBVDhPY+he8/B/7aK7/8vn3SEKg9SC9Kw+/OL/3Wdf/jOABCrnE6cZZAlILUjP3J1P/998/Pk/A7E2o6ubvuXx/+sPRw0YDQNqpQOKkzLFmQmUq0AZA5S2icEgtSA9h6+8+//0zbf/AJ4u1VVgG6hiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/b100y/img/square.png
// module id = vsRF
// module chunks = 1